@if (blocks$ | async; as blocks) {
  <div>
    <div class="container px-4 text-center">
      <div class="row mb-3">
        @for (block of blocks.firstRow; track block; let i = $index) {
          <div class="col-4 d-grid">
            <button type="button" class="btn btn-light border" (click)="triggerModal( block.data, block.title, block.dateType )">
              <h3>
                <span>{{ block.data.length }}</span>
                @if (i==0) {
                  <i class="fas fa-bell text-primary"></i>
                }
                @if (i==1) {
                  <i class="fas fa-star text-warning"></i>
                }
                @if (i==2) {
                  <i class="fas fa-check-circle text-success"></i>
                }
              </h3>
              <h6 class="text-secondary">{{block.title}}</h6>
            </button>
          </div>
        }
      </div>
      <div class="row">
        @for (block of blocks.secondRow; track block) {
          <div class="col-4 d-grid">
            <button type="button" class="btn btn-light border" (click)="triggerModal( block.data, block.title, block.dateType)">
              <h3>
                <span>{{ block.data.length }}</span>
              </h3>
              <h6 class="text-secondary text-break">{{block.title}}</h6>
            </button>
          </div>
        }
      </div>
    </div>
  </div>
} @else {
  <div class="widget-loading text-center">
    <i class="fas fa-circle-notch fa-spin"></i>
  </div>
}
